"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
require("./sis-document-row.component.scss");
/**
 *  Document item view control,with deleting and downloading possibilities.
 *  value:value which should pass using sis-document-row tag,
 *   @value is document(Classifier object which must  have 'fileName' property)
 *  remove-event on deleting document item
 *  onDownload- event on clicking  document item for downloading
 *  viewingValues- values passed by client, which should view on UI
 *  f.e. viewingValues=[document.getProperty('title').value,document.getProperty('uploadDate').value]...
 */
var DocumentItemComponent = /** @class */ (function () {
    function DocumentItemComponent() {
        this.viewingValues = [];
        this.isRemovable = true;
        this.remove = new core_1.EventEmitter();
        this.download = new core_1.EventEmitter();
    }
    DocumentItemComponent_1 = DocumentItemComponent;
    DocumentItemComponent.getExtensionOfFile = function (fileName) {
        return fileName.split('.').pop();
    };
    DocumentItemComponent.prototype.onRemove = function (removedValue) {
        this.remove.emit(removedValue);
    };
    DocumentItemComponent.prototype.onDownload = function (clickedValue) {
        this.download.emit(clickedValue);
    };
    // TODO: maybe fileType enum sarqenq
    DocumentItemComponent.prototype.getFileExtension = function () {
        var fileName = this.value.getProperty('DOCUMENTNAME').value;
        return DocumentItemComponent_1.getExtensionOfFile(fileName);
    };
    DocumentItemComponent = DocumentItemComponent_1 = __decorate([
        core_1.Component({
            inputs: ['id', 'value', 'viewingValues', 'isRemovable', 'currentLanguageId'],
            moduleId: module.id + '',
            outputs: ['remove', 'download'],
            selector: 'sis-document-row',
            template: require('./sis-document-row.component.html'),
        })
    ], DocumentItemComponent);
    return DocumentItemComponent;
    var DocumentItemComponent_1;
}());
exports.DocumentItemComponent = DocumentItemComponent;
//# sourceMappingURL=sis-document-row.component.js.map